import {
  Row,
  Col,
  Card,
  message,
  Form,
  Input,
  Switch,
  Button,
  Typography,
  Upload,
  Select,
  Space,
  Modal,
} from "antd";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import { useState, useEffect } from "react";
import axios from "axios";
import ClassifyStructure from "../classify/Main";
import InformationModal from "../classify/components/InformationModal";
import JoditEditor from "jodit-react";
import MarqeeEdit from "./components/MarqeeEdit";
import QAndAList from "./components/QAndAList";
import { CarouselManagement } from "./components/Carousel_news_ticker";
import ProTableOt from "../utility/ProTable_ot";
import WebsiteBasicInformationForm from "./views/WebsiteBasicInformationForm";
import { useWebsiteBasicInformation } from "./controller/WebsiteBasicInformationController";

const { Title } = Typography;

const Management = ({
  prefixTitle=""
}) => {
  const EditPhoto = ({ text, id }) => {
    const [logoFileId, setLogoFileId] = useState(null);
    const success_or_failure = (value) => {
      if (value === "success") {
        // notification.success({
        //   message: '成功',
        //   description: "編輯成功"
        // })
        return true;
      } else {
        // notification.error({
        //   message: '錯誤',
        //   description: "發生未知錯誤"
        // })
        return false;
      }
    };
    const uploadButton = (
      <div>
        <PlusOutlined />
        <div
          style={{
            marginTop: 8,
          }}
        >
          上傳
        </div>
      </div>
    );
    const delphoto = (fileid) => {
      axios
        .delete(`/shopping/api/mall/photo`, {
          data: { file: [{ file_id: fileid }] },
        })
        .then((response) => {
          setLogoFileId(null);
        });
    };
    const getFileUrl = (tmp) => {
      axios
        .get(`/shopping/api/mall/photo?file_id=${tmp}`, {
          responseType: "blob",
        })
        .then((response) => {
          var blob_ = new Blob([response.data], {
            type: "img/png",
          });
          const dataurl = URL.createObjectURL(blob_);
          setLogoFileId(dataurl);
        });
    };
    const setPhoto = (info, id) => {
      let formData = new FormData();
      formData.append(`file[0][inputFile]`, info.originFileObj);
      info.status === "done" &&
        axios.post(`/shopping/api/mall/file`, formData).then((response) => {
          getFileUrl(response.data?.file.find((tmp) => tmp).file_id);
          save(response.data?.file.find((tmp) => tmp).file_id, id);
        });
    };
    const dummyRequest = ({ file, onSuccess }) => {
      setTimeout(() => {
        onSuccess("ok");
      }, 0);
    };
    const save = (id, i) => {
      axios
        .patch("/shopping/api/company_data", {
          data: [
            { business_data_id: i, string_name: ``, string_text: ``, rate: id },
          ],
        })
        .then((response) => {
          success_or_failure(response.data.status);
        });
    };
    useEffect(() => {

      axios
        .get("shopping/api/company_data", { params: { business_data_id: id } })
        .then((response) => {
          response.data && getFileUrl(response.data.find((tmp) => tmp).rate);
        });
    }, []);
    return (
      <>
        <Row>
          <Col span={24}>
            {text}
            <Upload
              accept="image/png, image/jpeg, image/jpg"
              customRequest={dummyRequest}
              listType="picture-card"
              maxCount={1}
              onRemove={(e) => delphoto(e.file_id)}
              onChange={(e) => setPhoto(e.file, id)}
              showUploadList={false}
            >
              {logoFileId ? (
                <img
                  src={logoFileId}
                  alt="avatar"
                  style={{
                    width: "100%",
                  }}
                />
              ) : (
                uploadButton
              )}
            </Upload>
          </Col>
        </Row>
      </>
    );
  };
  const [form] = Form.useForm();

  const [form_data, set_form_data] = useState([]);
  const [axiosMode, setAxiosMode] = useState("patch");

  const onFormFinish = (values) => {
    if (axiosMode === "post") {
      postWebsiteBasicInformationData([values]);
    } else if (axiosMode === "patch") {
      patchWebsiteBasicInformationData([values]);
    }
  };
  const onFinish = ({ axiosMode, status, values }) => {
    if (status === "success") {
      if (axiosMode === "post") {
        message.success("送出成功");
        // actionRef.current.reloadAndRest();
      } else if (axiosMode === "patch") {
        message.success("修改成功");
        // actionRef.current.reloadAndRest();
      } else if (axiosMode === "delete") {
        message.success("刪除成功");
        // actionRef.current.reloadAndRest();
        // setSelectedRowKeys([])
        // setSelectedRowsInfo([])
      }
      // setModalLoading(false)
      // setModalOpen(false)
    } else if (status === "error") {
      if (axiosMode === "post") {
        message.error("新增失敗");
        // actionRef.current.reloadAndRest();
      } else if (axiosMode === "patch") {
        message.error("修改失敗");
        // actionRef.current.reloadAndRest();
      } else if (axiosMode === "delete") {
        message.error("刪除失敗");
        // actionRef.current.reloadAndRest();
      }
      // setModalLoading(false)
      // setModalOpen(false)
    }
  };
  const onBefore = ({ axiosMode, status, values }) => {
    // setModalLoading(true)
  };
  const {
    WebsiteBasicInformationData,
    getWebsiteBasicInformationData,
    postWebsiteBasicInformationData,
    patchWebsiteBasicInformationData,
    communityData,
    getCommunityData,
    // deleteAppointmentData,
  } = useWebsiteBasicInformation({
    onFinish,
    onBefore,
  });

  useEffect(() => {
    WebsiteBasicInformationData.forEach((item) => {
      form.setFieldsValue(item);
    });
  }, [WebsiteBasicInformationData]);
  useEffect(() => {
    document.title = `${prefixTitle} | 網站設定`

    getWebsiteBasicInformationData();
    getCommunityData();
  }, []);

  return (
    <Row
      gutter={[10, 20]}
      justify="space-around"
      style={{ padding: "20px", backgroundColor: "#f5f5f5" }}
    >
      <Col span={24}>
        <Card title="網站基本資料設定">
          <Row justify={"center"}>
            <Col span={24}>
              <Card
                style={{
                  background: "#F7F7F7",
                  borderRadius: "15px",
                  boxShadow: "0px 2px 4px 0px rgba(0, 0, 0, 0.25)",
                }}
              >
                <WebsiteBasicInformationForm
                  propsForm={form}
                  onFormFinish={onFormFinish}
                  selectOption={communityData}
                ></WebsiteBasicInformationForm>
              </Card>
            </Col>
          </Row>
        </Card>
      </Col>

      {/* <Col span={24}>
        <Card title="網站訊息公告設定">
          <Row gutter={[10, 20]} justify="space-around">
            <Col lg={8} md={24} sm={24} xs={24}>
              <MarqeeEdit />
            </Col>
            <Col lg={16} md={24} sm={24} xs={24}>
              <CarouselManagement />
            </Col>
          </Row>
        </Card>
      </Col> */}
      <Col span={24}>
        <Card title="網站Q&A設定">
          <QAndAList />
        </Card>
      </Col>
    </Row>
  );
};
export default Management;
